var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9873 23C20.4056 23 23.9873 19.4183 23.9873 15C23.9873 10.5817 20.4056 7 15.9873 7C11.569 7 7.9873 10.5817 7.9873 15C7.9873 19.4183 11.569 23 15.9873 23ZM15.9873 25C21.5102 25 25.9873 20.5228 25.9873 15C25.9873 9.47715 21.5102 5 15.9873 5C10.4645 5 5.9873 9.47715 5.9873 15C5.9873 20.5228 10.4645 25 15.9873 25ZM18.1086 18.5355L15.9873 16.4143L13.866 18.5355C13.4755 18.9261 12.8424 18.9261 12.4518 18.5355C12.0613 18.145 12.0613 17.5118 12.4518 17.1213L14.5731 15L12.4517 12.8787C12.0612 12.4882 12.0612 11.855 12.4517 11.4645C12.8423 11.0739 13.4754 11.0739 13.8659 11.4645L15.9873 13.5858L18.1087 11.4645C18.4992 11.0739 19.1324 11.0739 19.5229 11.4645C19.9134 11.855 19.9134 12.4882 19.5229 12.8787L17.4015 15L19.5228 17.1213C19.9133 17.5118 19.9133 18.145 19.5228 18.5355C19.1323 18.9261 18.4991 18.9261 18.1086 18.5355Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.f98cd6f0b44c0dc211c4dcd44604d659.svg";
export { ForwardRef as ReactComponent };